import React from 'react';
import {FormControl} from 'react-bootstrap';
import InputField, {InputFieldProps} from './InputField';
import {useValidation, ValidationProps} from '../../helpers/useValidation';

interface TextInputFieldProps extends InputFieldProps, ValidationProps {
    name: string;
    value: string | null | undefined;
    maxLength?: number;
    disabled?: boolean;
    rows?: number;
    onValueChanged?: (value: string, name: string) => void;
    type?: string;
}

function TextInputField<WrapperProps>(props: TextInputFieldProps) {
    const [errorCode, internalError, ref, onTouched] = useValidation(props);

    return (
        <InputField<WrapperProps>
            className={props.className}
            afterContent={props.afterContent}    
            descriptionKey={props.descriptionKey} 
            description={props.description} 
            editMode={props.editMode}
            error={internalError}
            errorCode={errorCode}
            wrapper={props.wrapper}
            wrapperProps={props.wrapperProps}
        >
            {renderValue(props, ref, onTouched)}
        </InputField>
    );
}

function renderValue(props: TextInputFieldProps, ref: React.RefObject<HTMLInputElement>, onTouched: () => void) {
    if (!props.editMode || !props.onValueChanged) {
        return <span>{props.value}</span>;
    }

    const onValueChanged = (e: any) => {
        onTouched();
        if (props.onValueChanged) {
            props.onValueChanged(e.target.value, props.name);
        }
    };

    return props.rows && props.rows > 1 ? 
        (
            <FormControl
                as="textarea"
                name={props.name}
                type={props.type || 'text'}
                value={props.value || ''}
                onChange={onValueChanged}
                maxLength={props.maxLength}
                disabled={props.disabled}
                rows={props.rows}
                ref={ref as any}
            />
        ) :
        (
            <FormControl
                as="input"
                name={props.name}
                type={props.type || 'text'}
                value={props.value || ''}
                onChange={onValueChanged}
                maxLength={props.maxLength}
                disabled={props.disabled}
                ref={ref as any}
            />
        )
}

export default TextInputField;
